var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.94 13.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.79 3.16A3.87 3.87 0 0 0 10 2a3.78 3.78 0 0 0-1.45.28 3.69 3.69 0 0 0-1.29.84L3.64 6.75A2.17 2.17 0 0 0 3 8.31a2.24 2.24 0 0 0 2.24 2.21 2.22 2.22 0 0 0 1.56-.64L10 6.72a.56.56 0 0 0 0-.78.59.59 0 0 0-.4-.16.55.55 0 0 0-.39.16L6 9.1a1.1 1.1 0 0 1-.78.32 1.18 1.18 0 0 1-.8-.33 1.11 1.11 0 0 1-.33-.78 1.07 1.07 0 0 1 .33-.78l3.64-3.6a2.76 2.76 0 0 1 2-.8 2.78 2.78 0 0 1 2.8 2.76A2.7 2.7 0 0 1 12 7.83l-3.84 3.82a4.1 4.1 0 0 1-2.9 1.18 4.11 4.11 0 0 1-2.92-1.2 4.06 4.06 0 0 1 0-5.76l5-4.93a.52.52 0 0 0 .12-.39.54.54 0 0 0-.17-.39A.55.55 0 0 0 6.9 0a.59.59 0 0 0-.4.16l-5 4.93A5 5 0 0 0 .38 6.8a5.21 5.21 0 0 0-.38 2 5 5 0 0 0 .39 1.9 5.17 5.17 0 0 0 2.88 2.85 5.53 5.53 0 0 0 2 .39 5.21 5.21 0 0 0 2-.38A5 5 0 0 0 9 12.43l3.8-3.82a3.67 3.67 0 0 0 .86-1.27 4 4 0 0 0 .28-1.45 3.84 3.84 0 0 0-1.15-2.73z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttachment);
export default __webpack_public_path__ + "static/media/file-attachment.cb78b1d68a2c68f23750592480d60662.svg";
export { ForwardRef as ReactComponent };